module.exports = __webpack_public_path__ + "img/icon_contract.01b8075c.png";